import { z } from 'zod';

export type BlockchainTransactionStatus = 'error' | 'pending' | 'success';
export type TransactionStatus = BlockchainTransactionStatus | 'none' | 'rejected' | 'waiting';

export const addressSchema = z.custom<`0x${string}`>(v => typeof v === 'string' && v.startsWith('0x'));
export type Address = z.infer<typeof addressSchema>;

export const bigIntSchema = z.preprocess(
  v => {
    if (typeof v === 'undefined') return '0';
    return v;
  },
  z.bigint({ coerce: true }),
);

export const swapInfoSchema = z.object({
  swapWrapper: addressSchema,
  tokenIn: addressSchema,
  amountIn: bigIntSchema,
  callData: z.string(),
  quote: z.object({
    priceImpact: z.number(),
    /** USDC value */
    expectedUsdc: bigIntSchema,
    /** USDC value */
    minimumTolerableUsdc: bigIntSchema,
    /** USDC value */
    endaomentFee: bigIntSchema,
  }),
  chainId: z.number(),
});
export type SwapInfo = z.infer<typeof swapInfoSchema>;

export enum TransactionAction {
  DEPLOY_ORG,
  CREATE_DONATION,
  EDIT_POSITION,
  BATCH_DEPLOY_ORG,
  DEPLOY_FUND,
  REBALANCE_FUND,
}

export type TransactionActionKey = keyof typeof TransactionAction;

export type StoredTransaction<Extra = unknown> = {
  status: BlockchainTransactionStatus;
  hash: Address;
  wallet: Address;
  type: TransactionActionKey;
  description: string;
  createdAt: number;
  onSelect?: () => void;
  extra: Extra;
  failCount: number;
  chainId: number;
};
